import Chip from '@mui/material/Chip';

import { TaskCheckTypeEnum } from '@/types/enums/task-check-type.enum';
import { t } from '@/utils/lang';

export interface StatusChipProps {
    status: TaskCheckTypeEnum;
    size?: 'small' | 'medium';
    showChip?: boolean;
}

const ChipTaskCheckType = ({
    status,
    size = 'medium',
    showChip = true,
}: StatusChipProps) => {
    let label: string;
    let color:
        | 'info'
        | 'warning'
        | 'success'
        | 'error'
        | 'default'
        | 'primary'
        | 'secondary';

    switch (status?.toLowerCase()) {
        case TaskCheckTypeEnum.CHECK.toLowerCase():
        case 'check':
            label = 'Kiểm tra';
            color = 'primary';
            break;

        case TaskCheckTypeEnum.REPAIR.toLowerCase():
        case 'repair':
            label = 'Sửa chữa';
            color = 'success';
            break;

        case TaskCheckTypeEnum.MAINTENANCE.toLowerCase():
        case 'maintenance':
            label = 'Bảo hành';
            color = 'info';
            break;

        default:
            label = 'Không xác định';
            color = 'default';
    }

    if (showChip) {
        return (
            <Chip variant='tonal' label={t(label)} color={color} size={size} />
        );
    }

    return {
        label: t(label, 'TaskCheckType'),
        color,
    };
};

export default ChipTaskCheckType;
